const initDblTapEvents = () => {
  let lastTap = 0;
  const delay = 300;

  document.addEventListener('touchend', (e) => {
    const { target } = e;
    const now = Date.now();
    const timeDiff = now - lastTap;

    if (timeDiff > 0 && timeDiff < delay) {
      const dblTapEvent = new CustomEvent('dbltap', {
        bubbles: true,
        cancelable: true,
        detail: { originalEvent: e },
      });

      target.dispatchEvent(dblTapEvent);
    }

    lastTap = now;
  });
};

initDblTapEvents();
